import { Field } from 'formik';
import { useIntl } from 'react-intl';
import { AddressFieldProps } from '../../types/fields';
import { AddressForm } from '../../utils/config';
import { Country } from '../../utils/countryData';
import getValidator from '../../utils/getValidator';
import { getStreetHouseNumberFormat } from '../../utils/address';
import TextField from '../formik/TextField';

type StreetHouseNumberFieldProps = AddressFieldProps & AddressForm['streetHouseNumber'] & { country: Country };

const StreetHouseNumberField = (props: StreetHouseNumberFieldProps) => {
  const { context, testIdPrefix, country, separateFields, houseNumber, street, ...validation } = props;
  const { formatMessage } = useIntl();
  const houseNumberField = (
    <div className="form__field-container">
      <Field
        name={`${context}.houseNumber`}
        component={TextField}
        label={formatMessage({ id: 'address.houseNumber' })}
        maxLength={houseNumber.maxLength}
        validate={getValidator(houseNumber)}
        data-test-id={`${testIdPrefix}-houseNumber`}
      />
    </div>
  );

  if (separateFields) {
    return (
      <>
        {houseNumber.position === 'first' && houseNumberField}
        <div className="form__field-container" style={{ flex: 4 }}>
          <Field
            name={`${context}.street`}
            component={TextField}
            label={formatMessage({ id: 'address.street' })}
            maxLength={street?.maxLength}
            validate={getValidator(street)}
            data-test-id={`${testIdPrefix}-street`}
          />
        </div>
        {houseNumber.position === 'second' && houseNumberField}
      </>
    );
  } else {
    return (
      <div className="form__field-container">
        <Field
          name={`${context}.streetHouseNumber`}
          component={TextField}
          label={formatMessage({ id: 'address.streetHouseNumber' })}
          maxLength={validation.maxLength}
          validate={getValidator({
            ...validation,
            format: getStreetHouseNumberFormat(country),
          })}
          data-test-id={`${testIdPrefix}-streetHouseNumber`}
        />
      </div>
    );
  }
};

export default StreetHouseNumberField;
